import React from "react";
import { MHW_MAINTENANCE } from "../../constants/maintenance";
import { useMhwMaintenance } from "../../hooks/useMhwMaintenance";
import Icon from "../ui/Icon";

/**
 * 의정원 점검 시간 동안 홈 상단에 띄우는 안내 띠. 시간창 밖에서는 아무것도 그리지 않는다.
 */
const MhwMaintenanceBanner: React.FC = () => {
  const isActive = useMhwMaintenance();
  if (!isActive) return null;

  return (
    <div
      role="status"
      className="mx-4 mb-2 rounded-xl bg-yellow-50 border border-yellow-200 px-4 py-3 flex items-start space-x-3"
    >
      <Icon
        name="alertTriangle"
        size="sm"
        className="text-yellow-700 flex-shrink-0 mt-0.5"
      />
      <div className="min-w-0">
        <p className="text-s font-semibold text-text-primary">
          건강정보 연동 기능 점검 안내
        </p>
        <p className="text-xs text-text-secondary mt-0.5 leading-relaxed">
          한국보건의료정보원 시스템 점검({MHW_MAINTENANCE.periodLabel})으로
          로그인·회원가입·의료기록 연동이 잠시 중단됩니다. AI 상담은 계속
          이용할 수 있습니다.
        </p>
      </div>
    </div>
  );
};

export default MhwMaintenanceBanner;
